'use client'
import { AdEndpointViews, getAdDecisionByType } from '@/app/util/ads-endpoint'
import AdsContext from '@/context/ads'
import { cn } from '@/util/cn'
import { useContext } from 'react'
import { InView } from 'react-intersection-observer'
import { isEmpty } from 'utils'
import { isValidActiveBanner } from '../app/util/banner'
import UAParserContext from '../context/ua-parser'
import AdBanner, { getAdBannerData } from './homepage/ad-banner'
import { fireAdTrackingPixel } from '@/util/ad-click'

const Banner = () => {
    const { deviceType } = useContext(UAParserContext)
    const { banner } = useContext(AdsContext)

    if (!banner || isEmpty(banner)) {
        return null
    }
    const isAdBanner = !isValidActiveBanner(banner)
    return isAdBanner ? (
        <AdBanner gif={banner} deviceType={deviceType} />
    ) : (
        <div
            className="ci-hidden h-[22vw] md:h-[96px] md:w-desktopWidth"
            onClick={() => {
                location.href = banner.link
            }}
        >
            <img
                className="h-full w-full object-cover"
                src={deviceType === 'desktop' ? banner.image : banner.image_mobile}
                alt={banner.alt_text}
            />
        </div>
    )
}

const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
// if there is a server side ad decision show a placeholder while the clientside loads
export const GeotargetedBanner = ({
    view,
    className,
    aspectRatio,
}: {
    view: AdEndpointViews
    className?: string
    aspectRatio?: number
}) => {
    const { adClientData, adServerData } = useContext(AdsContext)
    const { deviceType } = useContext(UAParserContext)
    const serverDecision = getAdDecisionByType(adServerData, view)

    if (!serverDecision?.gif?.images?.original) {
        return null
    }
    const clientDecision = getAdDecisionByType(adClientData, view)
    const decision = clientDecision || serverDecision
    const { gif, click_url, click_tracking_url, cta_text, impression_url } = decision
    const { width, height } = gif.images.original
    const src = clientDecision ? getAdBannerData(gif, deviceType).url : placeholder

    return (
        <a
            href={click_url}
            target="_blank"
            className={cn('block transition-all duration-100', className, click_url && 'cursor-pointer')}
            style={{ aspectRatio: aspectRatio || width / height }}
            onClick={() => {
                fireAdTrackingPixel(click_tracking_url)
            }}
        >
            <InView
                as="img"
                className="h-full w-full object-cover"
                alt={cta_text}
                src={src}
                triggerOnce
                onChange={(inView) => {
                    // only fires once when in view because of triggerOnce, but test for inView anyway
                    if (impression_url && inView) {
                        try {
                            fireAdTrackingPixel(impression_url)
                        } catch (e) {
                            console.error(`Error with tracking pixel for geotargeted banner`, e)
                        }
                    }
                }}
            />
        </a>
    )
}

export default Banner
